import { PROFILE } from "../data/links";

export default function Footer() {
  return (
    <footer data-testid="footer" className="border-t border-white/10 mt-12">
      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 py-10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[10px] sm:text-xs tracking-[0.25em] uppercase text-white/40">
        <span>&copy; {new Date().getFullYear()} TEZZO</span>
        <span>{PROFILE.handle}</span>
      </div>
    </footer>
  );
}
